<template>
  <div class="relation">
    <div class="contentWidth">
      <div :class="'address '+(addressIndex==1?'addressChange':'')" @mouseover='addressHover(1)' @mouseleave='addressLeave()'>
        <img src="../../assets/img/relation/bj.png" alt="">
        <div class="addressZZ">

        </div>
        <div class="addressKP">
          <h2>北京总部</h2>
          <p>
            <span>
              地址：北京市朝阳区酒仙桥14号兆维工业园区C3座3层
            </span><br><br>
            <span>
              联系方式：010-59547322
            </span><br>
            <span>
              邮箱：<a href="mailto:yunying@intelinkgroup.com">yunying@intelinkgroup.com</a>
            </span>
          </p>
        </div>
      </div>
      <div :class="'address '+(addressIndex==2?'addressChange':'')" @mouseover='addressHover(2)' @mouseleave='addressLeave()'>
        <img src="../../assets/img/relation/sh.png" alt="">
        <div class="addressZZ">

        </div>
        <div class="addressKP">
          <h2>上海分公司</h2>
          <p>
            <span>
              地址：上海中山南二路440号1幢宝溢丰大厦19层CD室
            </span><br><br>
            <span>
              <!-- 联系方式：021-60334022 -->
            </span><br>
            <span>
              <!-- 邮箱：<a href="mailto:yunying@intelinkgroup.com">yunying@intelinkgroup.com</a> -->
            </span>
          </p>
        </div>
      </div>
      
      <div :class="'address '+(addressIndex==3?'addressChange':'')" @mouseover='addressHover(3)' @mouseleave='addressLeave()'>
        <img src="../../assets/img/relation/gz.png" alt="">
        <div class="addressZZ">

        </div>
        <div class="addressKP">
          <h2>广州分公司</h2>
          <p>
            <span>
              地址：广州市天河区花城大道85号2501
            </span><br><br>
            <span>
              <!-- 联系方式：020-28837693 -->
            </span><br>
            <span>
              <!-- 邮箱：<a href="mailto:yunying@intelinkgroup.com">yunying@intelinkgroup.com</a> -->
            </span>
          </p>
        </div>
      </div>
      
      <div :class="'address '+(addressIndex==4?'addressChange':'')" @mouseover='addressHover(4)' @mouseleave='addressLeave()'>
        <img src="../../assets/img/relation/hz.png" alt="">
        <div class="addressZZ">

        </div>
        <div class="addressKP">
          <h2>杭州分公司</h2>
          <p>
            <span>
              地址：杭州市西湖区黄龙时代广场B座15层
            </span><br><br>
            <span>
              <!-- 联系方式：0571-28255058 -->
            </span><br>
            <span>
              <!-- 邮箱：<a href="mailto:yunying@intelinkgroup.com">yunying@intelinkgroup.com</a> -->
            </span>
          </p>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import ZSelect from '../modules/Zselect'
export default {
  name: 'relation',
  components:{ZSelect},
  data () {
    return {
      addressIndex:8,
    }
  },
  methods: {
    addressHover(data){
      this.addressIndex = data
    },
    addressLeave(){
      this.addressIndex = 8
    }
  },
  mounted(){
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less"> 
.relation{
  padding-top: 50px;
  // height: 90%;
  .address{
    height:300px;
    width: 900px;
    margin: 40px auto;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    img{
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
    }
    .addressKP{
      a{
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        text-decoration:none !important;
        out-line: none !important;
        color: #828282 !important;
      }
      display: inline-block;
      position: absolute;
      height: 100%;
      width: 40%;
      background: #f7f7f7;
      z-index: 3;
      right: 0;
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
      h2{
        font-size: 24px;
        color: #0168b7;
        position: absolute;
        top: 20px;
        left: 40%;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
      }
      p{
        display: inline-block;
        width: 250px;
        font-size: 14px;
        color: #828282;
        position: absolute;
        top: 100px;
        left: 20%;
        line-height: 24px;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        span{
        }
      }
    }
    .addressZZ{
      display: inline-block;
      position: absolute;
      height: 100%;
      width: 100%;
      background: rgba(0,0,0,0);
      z-index: 3;
      right: 0;
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
    }
    img{
      position: absolute;
      height: 100%;
      left: 0;
      z-index: 1;
    }
  }
  .addressChange{
    img{
      transform:scale(1.2);
      -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
    }
    .addressKP{
      width: 50%;
      background: #0168b7;
      a{
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        text-decoration:none !important;
        out-line: none !important;
        color: #fff !important;
      }

      p{
        color: #fff;
      }
      h2{
        color: #fff;
      }
    }
    .addressZZ{
      background: rgba(0,0,0,0.5);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/relation.vue